import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delete",
  "use": "delete-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"delete\"><path fill-rule=\"evenodd\" d=\"M8 21.5h8c1.1 0 2-.9 2-2v-11H6v11c0 1.1.9 2 2 2Zm8-17-1.5-2h-5L8 4.5H5v2h14v-2h-3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol